import { render, staticRenderFns } from "./IncidentsAddEdit.vue?vue&type=template&id=d1ebdea4&"
import script from "./IncidentsAddEdit.vue?vue&type=script&lang=ts&"
export * from "./IncidentsAddEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports